import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getNestedProperty } from "../../helpers/getNestedProperty";
import { StatusInputWrapper } from "../StatusInputWrapper";
import styles from './Address.module.scss';

// address autofill is only used for Home Address input fields and not for mailing address fields
const MailingAddressAutofill = ({
  t,
  label,
  reduxAppProperty,
  changeObjectPropertyAction,
  validateMailingAddress,
  mailingAddressError,
  mailingAddressValid,
  setIsError,
  validateCity,
  cityError,
  cityValid,
  validatePostalCode,
  postalCodeError,
  postalCodeValid,
  setCanadaPostAPIResponse
}) => {

  const apiKey = process.env.REACT_APP_CANADA_POST_API_KEY;
  const provinceCode = 'NS';
  const country = 'CAN';
  const [isFocussed, SetIsFocussed] = useState(false);

  const street = useSelector(
    (state) => getNestedProperty(state.app, reduxAppProperty).street
  );
  let city = useSelector(
    (state) => getNestedProperty(state.app, reduxAppProperty).city
  );
  let postalCode = useSelector(
    (state) => getNestedProperty(state.app, reduxAppProperty).postalCode
  );

  //turns dropdown on and off
  const [display, setDisplay] = useState(false);

  const [streetname, setStreetname] = useState([]);

  const [cityName, setCityName] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [isFocussed2, SetIsFocussed2] = useState(false);
  const [postalCodeReadOnly, setPostalCodeReadOnly] = useState(true);
  const [cityReadOnly, setCityReadOnly] = useState(true);
  const [focusedItem, setFocusedItem] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    // Scroll to the selected item when it changes
    if (focusedItem !== null && containerRef.current) {
      const focusedItemElement = containerRef.current.children[focusedItem];
      if (focusedItemElement) {
        focusedItemElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }
  }, [focusedItem]);

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowUp') {
      setFocusedItem((prev) => (prev === null ? 0 : (prev - 1 + suggestions.length) % suggestions.length));
    } else if (event.key === 'ArrowDown') {
      setFocusedItem((prev) => (prev + 1) % suggestions.length);
    } else if (event.key === 'Enter' && focusedItem !== null && focusedItem !== 0) {
      setAddressInput(suggestions[focusedItem]);
      setCityInput(suggestions[focusedItem]?.Description);
    }
  };


  const handleStreetAddress = async (e) => {
    const term = e.target.value;
    if (term !== "") {
      setDisplay(true);
    }
    changeObjectPropertyAction("street", term);
    changeObjectPropertyAction("city", '');
    changeObjectPropertyAction("postalCode", '');
    setFocusedItem(0);
    if (term.length >= 0) {
      try {
        const response = await axios.get(
          `https://ws1.postescanada-canadapost.ca/addresscomplete/Interactive/Find/v2.10/json3ex.ws?Key=${apiKey}&&Country=${country}&&SearchTerm=${encodeURIComponent(
            term
          )}&&ProvinceList=['${provinceCode}']&&MaxSuggestions=${30}`
        );
        if (response?.data?.Items?.length > 0) {
          const { Items } = response?.data;
          const filteredAddresses = filterAddressesByProvince(Items); // Specify the desired provinces here
          validateMailingAddress(term, null);
          setCanadaPostAPIResponse(true);
          validateCity(null, null);
          validatePostalCode(null, null);
          setSuggestions(filteredAddresses);
        }
        else {
          validateMailingAddress(term, false);
          setCanadaPostAPIResponse(false);
          validateCity(null, true);
          validatePostalCode(null, true);
          setCityInput(null);
          setSuggestions([]);
        }
      } catch (error) {
        validateMailingAddress(term);
        setCanadaPostAPIResponse(false);
        validateCity(null, true);
        setPostalCodeReadOnly(false);
        setCityReadOnly(false);
        validatePostalCode(null, true);
        setCityInput(null);
        setSuggestions([]);
        console.error(error);
      }
    }
    else {
      validateMailingAddress(term);
      // setCityInput('');
      validateCity(null, false);
      validatePostalCode(null, false);
      setSuggestions([]);
    }
  };

  const getUnits = async (address) => {
    const { Text, Id } = address;
    try {
      const response = await axios.get(
        `https://ws1.postescanada-canadapost.ca/Capture/Interactive/Find/v1.00/json3ex.ws?Key=${apiKey}&&Country=${country}&&Text=${Text}&&Container=${Id}`
      );
      if (response?.data?.Items?.length > 0) {
        const { Items } = response?.data;
        const filteredAddresses = filterAddressesByProvince(Items); // Specify the desired provinces here
        setSuggestions(filteredAddresses);
      }
    } catch (error) {
      // validateMailingAddress(term);
      setCityInput('');
      setSuggestions([]);
      console.error(error);
    }

  };

  const filterAddressesByProvince = (addresses) => {
    return addresses.filter((address) => address?.Description?.includes(', NS,'));
  };

  const onBlurStreetAddress = (e) => {
    try {
      SetIsFocussed(false);
      let name = e.currentTarget.value.trim();
      changeObjectPropertyAction("street", name);

      // validateMailingAddress(name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const onClickStreetAddress = (e) => {
    try {
      setDisplay(!display);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  //triggered by onClick of address dropdown div
  const setAddressInput = (item) => {
    setStreetname(item?.Text);
    if (item?.Next === 'Find') {
      getUnits(item);
    }
    else {
      changeObjectPropertyAction("street", item?.Text);
      validateMailingAddress(item?.Text);
      setDisplay(false);
    }
  };

  const setCityInput = (val) => {
    try {
      if (val) {
        const arr = val?.split(',');
        changeObjectPropertyAction("city", arr[0]?.trim());
        validateCity(arr[0]?.trim());
        changeObjectPropertyAction("provinceState", arr[1]?.trim());
        setPostalInput(arr[2]?.slice(0, 8)?.trim());
      }
      else {
        changeObjectPropertyAction("city", val);
      }
      setCityName(val);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const handleCity = (e) => {
    try {
      let name = e.currentTarget.value;
      changeObjectPropertyAction("city", name);
      validateCity(name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const onBlurCity = (e) => {
    try {
      SetIsFocussed2(false);
      let name = e.currentTarget.value.trim();
      changeObjectPropertyAction("city", name);
      validateCity(name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const setPostalInput = async (name) => {
    try {
      changeObjectPropertyAction("postalCode", name);
      // validatePostalCode(name?.replace(" ", "")?.toUpperCase());
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const handlePostalCode = (e) => {
    try {
      let name = e.currentTarget.value;
      changeObjectPropertyAction("postalCode", name);
      // validatePostalCode(name.replace(" ", "").toUpperCase());
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const onBlurPostalCode = (e) => {
    try {
      SetIsFocussed(false);
      let name = e.currentTarget.value.replace(" ", "").toUpperCase();
      changeObjectPropertyAction("postalCode", name);
      // validatePostalCode(name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const handleClickOutside = (event) => {
    // Check if the clicked target is outside the div
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setDisplay(false)
      // Your code to handle the click outside event
    }
  };

  useEffect(() => {
    // Add event listener when component mounts
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener when component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // --------------------------------------------------------------------------------------------------------------------------------------

  const warningContent = (<div>

    {t("home_information.warning_text2_2")}
    <a href="tel:9024245200">902-424-5200</a>{" "}
    {t("home_information.warning_text2_3")}{" "}
    <a href="tel:18006704357">1-800-670-4357</a>
    {t("home_information.warning_text2_4")}
    <a href="mailto:onlinehelp@novascotia.ca">onlinehelp@novascotia.ca</a>
    . </div>)




  return (
    <div className="row" style={{ position: "relative" }}>
      <StatusInputWrapper
        isValid={mailingAddressValid}
        errorMsg={mailingAddressError}
        t={t}
        label={label ?? t("home_information.mailing_address")}
        helperText={t("home_information.mailing_address_helper")}
        isFocussed={isFocussed}
        id="MailingAddress"
        name="MailingAddress"
        type="text"
        customClasses={"fw-20"}
        aria-describedby="mailing-address"
        onClick={onClickStreetAddress}
        onChange={handleStreetAddress}
        onBlur={onBlurStreetAddress}
        onFocus={() => SetIsFocussed(true)}
        value={street}
        autoComplete="off"
        maxLength="150"
        onKeyDown={handleKeyDown}
        tabIndex={0}
      />
      {display && (
        <div
          ref={containerRef}
          className="autoContainer" style={{
            overflowY: 'scroll',
            maxHeight: '300px', width: 'auto'
          }}>
          {suggestions.map((item, i) => {
            return (
              <div
                aria-selected={i === focusedItem}
                style={{ cursor: "pointer", width: 'auto' }}
                className={i === focusedItem ? styles['focused'] : 'option'}
                onClick={() => {
                  setAddressInput(item);
                  setCityInput(item?.Description);
                  // setPostalInput(i);
                  // validateMailingAddress(item.Text + ', ' + item.Description);
                }}
                key={item.Id}
              >
                <span className="col-xs-10 col-md-8">{item?.Text}{', '} {item?.Description}
                  {item?.Next === 'Find' ? <i style={{ marginLeft: "20px" }} class="fa fa-greater-than"></i> : ''}
                </span>
              </div>
            );
          })}
        </div>
      )}

      <StatusInputWrapper
        isValid={cityValid}
        errorMsg={cityError}
        t={t}
        label={t("mailing_address.city")}
        customClasses={"fw-10"}
        id="City"
        name="City"
        type="text"
        readOnly={cityReadOnly}
        isFocussed={isFocussed2}
        aria-describedby="city"
        onChange={handleCity}
        onBlur={onBlurCity}
        onFocus={() => SetIsFocussed2(true)}
        value={city}
        autoComplete="off"
        maxLength="50"
      />

      <StatusInputWrapper
        readOnly={postalCodeReadOnly}
        isValid={postalCodeValid}
        errorMsg={postalCodeError}
        t={t}
        label={t("mailing_address.postal_code")}
        id="PostalCode"
        name="PostalCode"
        type="text"
        isFocussed={isFocussed}
        aria-describedby="postal-code"
        customClasses={"fw-6"}
        onChange={handlePostalCode}
        onBlur={onBlurPostalCode}
        onFocus={() => SetIsFocussed(true)}
        value={postalCode}
        autoComplete="off"
        maxLength="7"
      />
      {/* Province - hard coded */}
      <div className="ns-label-wrapper" style={{
        marginBottom: ".5em", background: "#EEEEEE",
        border: "1px solid #D9D9D9", height: "100px"
      }} >
        <label className="ns-label">
          {t("home_information.mailing_address")}:
        </label>

        <div style={{ marginBottom: ".5em" }} className="ns-hint">
          {street ? street : ''} {city ? ', ' + city + ', NS' : ''}
          {postalCode ? ',  ' + postalCode : ''}
        </div>
      </div>

    </div>
  );
};

export default withTranslation("common")(MailingAddressAutofill);
